// @ts-check
// The time zone list: every zone the browser knows, grouped by region, each
// with its current offset. Settings → Appearance (your time zone) and Settings
// → Sessions (the zone online booking runs in) both draw it from here.

const REGION_ORDER = ['America', 'Europe', 'Asia', 'Australia', 'Pacific', 'Africa', 'Indian', 'Atlantic', 'Arctic', 'Antarctica'];

/**
 * @param {string} selected the zone to mark selected
 * @returns {string} the <optgroup> and <option> markup
 */
export function timeZoneOptionsHtml(selected) {
  const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  /** @type {string[]} */
  let zones;
  // supportedValuesOf is newer than the TypeScript lib this repo checks against.
  try { zones = /** @type {any} */ (Intl).supportedValuesOf('timeZone'); } catch { zones = [browserTz]; }
  // A stored zone the list lacks still shows, rather than silently becoming
  // the first option and being saved over.
  if (selected && !zones.includes(selected)) zones = [...zones, selected];

  /** @type {Record<string, Array<{tz: string, label: string}>>} */
  const groups = {};
  const now = new Date();
  for (const tz of zones) {
    const region = tz.split('/')[0] || 'Other';
    if (!groups[region]) groups[region] = [];
    let offset = '';
    try {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' }).formatToParts(now);
      offset = parts.find((p) => p.type === 'timeZoneName')?.value || '';
    } catch { /* an unknown zone shows without an offset */ }
    const city = tz.split('/').slice(1).join('/').replace(/_/g, ' ');
    groups[region].push({ tz, label: `${city || tz} (${offset})` });
  }

  const regions = Object.keys(groups).sort((a, b) => {
    const ai = REGION_ORDER.indexOf(a), bi = REGION_ORDER.indexOf(b);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });

  let html = '';
  for (const region of regions) {
    const items = groups[region].sort((a, b) => a.label.localeCompare(b.label));
    html += `<optgroup label="${region}">`;
    for (const item of items) {
      html += `<option value="${item.tz}" ${item.tz === selected ? 'selected' : ''}>${item.label}</option>`;
    }
    html += '</optgroup>';
  }
  return html;
}
